export default __webpack_public_path__ + "static/media/signup-icon.54da70c6.svg";